export const NACE_SECTORS = [
  { code: "A", label: "Agriculture, forestry and fishing", translationKey: "naceSector.A" },
  { code: "B", label: "Mining and quarrying", translationKey: "naceSector.B" },
  { code: "C", label: "Manufacturing", translationKey: "naceSector.C" },
  { code: "D", label: "Electricity, gas, steam and air conditioning supply", translationKey: "naceSector.D" },
  { code: "E", label: "Water supply; sewerage, waste management and remediation activities", translationKey: "naceSector.E" },
  { code: "F", label: "Construction", translationKey: "naceSector.F" },
  { code: "G", label: "Wholesale and retail trade; repair of motor vehicles and motorcycles", translationKey: "naceSector.G" },
  { code: "H", label: "Transportation and storage", translationKey: "naceSector.H" },
  { code: "I", label: "Accommodation and food service activities", translationKey: "naceSector.I" },
  { code: "J", label: "Information and communication", translationKey: "naceSector.J" },
  { code: "K", label: "Financial and insurance activities", translationKey: "naceSector.K" },
  { code: "L", label: "Real estate activities", translationKey: "naceSector.L" },
  { code: "M", label: "Professional, scientific and technical activities", translationKey: "naceSector.M" },
  { code: "N", label: "Administrative and support service activities", translationKey: "naceSector.N" },
  { code: "O", label: "Public administration and defence; compulsory social security", translationKey: "naceSector.O" },
  { code: "P", label: "Education", translationKey: "naceSector.P" },
  { code: "Q", label: "Human health and social work activities", translationKey: "naceSector.Q" },
  { code: "R", label: "Arts, entertainment and recreation", translationKey: "naceSector.R" },
  { code: "S", label: "Other service activities", translationKey: "naceSector.S" },
  { code: "T", label: "Activities of households as employers; undifferentiated goods- and services-producing activities of households for own use", translationKey: "naceSector.T" },
  { code: "U", label: "Activities of extraterritorial organisations and bodies", translationKey: "naceSector.U" },
] as const;

export type NaceSectorCode = typeof NACE_SECTORS[number]["code"];

export const getNaceSectorLabel = (code: string): string | undefined => {
  return NACE_SECTORS.find(s => s.code === code)?.label;
};

export const getTranslatedNaceSectorLabel = (code: string): string | undefined => {
  const sector = NACE_SECTORS.find((entry) => entry.code === code);
  return sector?.label;
};

export const getTranslatedNaceSectorOptions = () =>
  NACE_SECTORS.map((sector) => ({
    ...sector,
    translatedLabel: sector.label,
  }));

export const isValidNaceCode = (code: string): boolean => {
  return NACE_SECTORS.some(s => s.code === code);
};
